export const getCurrentSiteSectionSlugFromPathname = (pathname: string) => {
	const segments = pathname.split('/');
	const siteSectionSlug = segments[1];

	return siteSectionSlug;
};
